import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { contentWorkOf } from "constants/works";

const DEFAULT_LANGUAGE = "ja";

export const useUrlParams = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  return useMemo(() => {
    const soulId = queryParams.get("soul_id");
    const work = location.pathname.split("/")[1];
    return {
      soulId,
      lng: queryParams.get("lng") || DEFAULT_LANGUAGE,
      // 画面の行き先と Backend は work、見た目と文言は contentWork で引く
      work,
      contentWork: contentWorkOf(work),
      character: soulId?.split("_")[0],
    };
  }, [location]);
};
